export default "__VITE_ASSET__DWFHgkOA__"